import { useState } from 'react'
import { useTranslation } from 'libs/i18n'
import { GridIcon } from 'shared/atoms'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'
import {
	Area,
	FloorDimentions,
	Text,
	Rectangle,
	Circle,
	Line,
	ImageEl,
	SelectedArea
} from './components'
import { OpenSectionContext } from './components/Field'
import type { FloormapConfig } from 'features/editor'

type EditorSidebarProps = WithClassName<{
	floormapConfig: FloormapConfig
	gridStep: number
	floorSize: { width: number; height: number }
	selectedElement?: FloormapConfig[number]
	onSubmit: (data: FloormapConfig) => void
	onResize: (key: 'width' | 'height' | 'radius', value: number) => void
}>

export const EditorSidebar = ({
	floormapConfig,
	gridStep,
	floorSize,
	selectedElement,
	className,
	onSubmit,
	onResize
}: EditorSidebarProps) => {
	const { t } = useTranslation()
	const [openSection, setOpenSection] = useState<string | null>('booth')

	const toggleSection = (section: string) =>
		setOpenSection((current) => (current === section ? null : section))

	return (
		<OpenSectionContext.Provider value={{ openSection, toggleSection }}>
			<div className={cn('space-y-1', className)}>
				<FloorDimentions floormapConfig={floormapConfig} onSubmit={onSubmit} />
				<Area floormapConfig={floormapConfig} onSubmit={onSubmit} />
				<Text floormapConfig={floormapConfig} onSubmit={onSubmit} />
				<Rectangle floormapConfig={floormapConfig} onSubmit={onSubmit} />
				<Circle floormapConfig={floormapConfig} onSubmit={onSubmit} />
				<Line floormapConfig={floormapConfig} onSubmit={onSubmit} />
				<ImageEl floormapConfig={floormapConfig} onSubmit={onSubmit} />
				{selectedElement && (
					<SelectedArea element={selectedElement} floorSize={floorSize} onChange={onResize} />
				)}
				<p className="flex items-center gap-2 pt-2 text-xs text-muted-foreground">
					<GridIcon className="h-3.5 w-3.5 shrink-0" />
					{t('Grid: {{ size }} px', { size: gridStep })}
				</p>
			</div>
		</OpenSectionContext.Provider>
	)
}
